import React, {
  useEffect,
} from 'react';
import {
  DateTime,
} from 'luxon';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  getUiState,
} from 'web-selectors';

import {
  Dashboard,
} from 'web-components';

const mapState = (state) => {
  const profile = coreSelectors.getProfile(state);
  return {
    profile,
    namespace: getUiState('namespace')(state),
  };
};

const DashboardPage = () => {
  const dispatch = useDispatch();
  const {
    profile,
    namespace,
  } = useSelector(mapState, shallowEqual);

  const isPro = profile.is_pro;

  useEffect(() => {
    dispatch(
      coreActions.requestDashboards(isPro),
    );
    const now = DateTime.local();
    const params: {
      range_from: string,
      range_to: string,
      scope?: string,
    } = {
      range_from: now.minus({ days: 7 }).toISO(),
      range_to: now.plus({ days: 7 }).toISO(),
    };
    if (isPro) {
      dispatch(
        coreActions.requestClientsPerformance(),
      );
      params.scope = 'all_with_clients';
    }
    dispatch(
      coreActions.requestLoadWorkoutEvents({
        params,
      }),
    );
  }, []);

  return (
    <Dashboard
      profile={profile}
      namespace={namespace}
    />
  );
};

export default DashboardPage;
